import { StyledListItemIcon } from "@app/shared/walletAddressListBilling/Sidebar/SideBarFolderItem/index.styled";
import { WalletType } from "@lib/types/Billing";
import { SendByteWalletType } from "@lib/types/SendByte";
import { AiTwotoneUsb } from "react-icons/ai";
import { GiWallet } from "react-icons/gi";
import { HiQrcode } from "react-icons/hi";
import { IoHardwareChip } from "react-icons/io5";

type Props = {
  type: WalletType | SendByteWalletType;
  sidebarCollapsed: boolean;
};

export default function WalletTypeIcon({ type, sidebarCollapsed }: Props) {
  const IconByName: any = {
    hot: <GiWallet />,
    cold: <AiTwotoneUsb />,
    hardware: <IoHardwareChip />,
    paper: <HiQrcode />,
    multisig: <GiWallet />,
    custodial: <GiWallet />,
  };

  return (
    <StyledListItemIcon
      style={{ marginRight: 10, display: sidebarCollapsed ? "none" : "block" }}
    >
      {IconByName[type]}
    </StyledListItemIcon>
  );
}
